<template> 
  <div class="layout">
    <Toast position="top-right" />
    <Toast position="top-center" group="tc" />
    <div class="layout-sidebar">
      <sidebar />
    </div>
    <div class="layout-main">
      <RouterView />
    </div>
  </div>
</template>



<script setup>
import { inject } from 'vue';
import { RouterLink, RouterView } from 'vue-router';
import sidebar from '../sidebar/sidebar.vue';
import { useContextStore } from '@wholebodyapp/stores';
import Toast from '@wholebodyapp/ui-components/src/components/toast/toast.vue';

const context = useContextStore();
const user = context.getUser;

</script>



<style lang="scss">
  @use '@wholebodyapp/design/colors/palette' as *;

  body {
    margin: 0;
  }
  .layout {
    background-color: #fff;
    display: grid;
    grid-template-columns: [sidebar] 320px [client] 1fr;
    grid-template-rows: [client] 1fr;
    height: 100vh;
    overflow: hidden;
  }
  .layout-sidebar {
    background: var(--default-bg);
    border-right: 1px solid $gray-200;
    grid-column: 1 / sidebar;
    grid-row:  1  / end;
    overflow-y: auto;
  }
  .layout-menu {
    // background-color: rgba(200, 0, 0, 0.25);
    border-bottom: 1px solid var(--default-surface-border);
    grid-column: client / end;
    grid-row: 1 / breadcrumb;
  }
  .layout-breadcrumb {
    // background-color: rgba(0, 200, 0, 0.25);
    border-bottom: 1px solid var(--default-surface-border);
    grid-column: client / end;
    grid-row: breadcrumb / client;
  }
  .layout-main {
    grid-column: client / end;
    grid-row: client / end;
    overflow: auto;
  }
</style>
